import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';
import {showFailToast, showToast} from "vant";
import {useUserTreatmentSessionStore} from "@/stores/userTreatmentSession.store";
import {userUserNotificationStore} from "@/stores/userNotification.store";


const baseUrl = `${process.env.VUE_APP_API_URL}/auth`;

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        returnUrl: null
    }),
    actions: {
        async loginV1(token) {
            try {
                const response = await fetchWrapper.get(`${baseUrl}/login/v1` + '?token=' + token);

                // update pinia state
                this.user = response.data;

                localStorage.removeItem('user');
                localStorage.setItem('user', JSON.stringify(this.user));

                //reset all states
                const userTreatmentSessionStore = useUserTreatmentSessionStore();
                userTreatmentSessionStore.reset();

                const userNotificationStore = userUserNotificationStore();
                userNotificationStore.reset();

                // redirect to previous url or default to home page
                await this.$router.push(this.returnUrl || '/account');
            } catch (error) {
                this.user = null;
                localStorage.removeItem('user');
                this.$router.push('/login');
            }
        },

        async login(username, password) {
            try {
                const response = await fetchWrapper.post(`${baseUrl}/login`, { username, password });

                // update pinia state
                this.user = response.data;

                localStorage.removeItem('user');
                localStorage.setItem('user', JSON.stringify(this.user));

                //reset all states
                const userTreatmentSessionStore = useUserTreatmentSessionStore();
                userTreatmentSessionStore.reset();

                const userNotificationStore = userUserNotificationStore();
                userNotificationStore.reset();

                // redirect to previous url or default to home page
                await this.$router.push(this.returnUrl || '/');
            } catch (error) {
                showToast({
                    message: error,
                    wordBreak: 'break-word',
                });
            }
        },

        async register(username, password, first_name, last_name, account_id, nickname) {
            try {
                const user = await fetchWrapper.post(`${baseUrl}/register`, { username, password, first_name, last_name, account_id, nickname });
                this.user = user;
                localStorage.removeItem('user');
                localStorage.setItem('user', JSON.stringify(user));
                await this.$router.push('/login');
            } catch (error) {
                showFailToast(error);
            }
        },

        logout() {
            this.user = null;
            localStorage.removeItem('user');
            this.$router.push('/login');
        }
    }
});
